import { Spacer } from "@hackthenorth/north";
import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/24/solid";
import { Alert } from "north.js";
import React, { useState } from "react";
import styled from "styled-components";

import { Modal } from "src/shared/components";
import { useMyGooseGamePlayerQuery } from "src/views/goose-games/graphql/hacker/myGooseGamePlayer.generated";
import { useSubmitGooseGameQuestionQuestLogMutation } from "src/views/goose-games/graphql/hacker/submitGooseGameQuestionQuestLog.generated";
import { Quest, QuestType } from "src/views/goose-games/types";

import FooterActions from "../../../../footerActions";

import InputQuestView from "./view/input";
import ScannedQuestView from "./view/scanned";
export interface QuestModalProps {
  isOpen: boolean;
  onClose: () => void;
  refetchQuest: () => void;
  quest: Quest;
  progress?: number;
}
const QuestModal: React.FC<QuestModalProps> = ({
  isOpen,
  onClose,
  refetchQuest,
  quest,
  progress,
}) => {
  const [isCompleted, setIsCompleted] = useState(false);
  const [answer, setAnswer] = useState("");
  const [isAnswerCorrect, setIsAnswerCorrect] = useState<boolean | null>(null);

  const [submitQuestion] = useSubmitGooseGameQuestionQuestLogMutation();
  const { data: myGooseGamePlayer } = useMyGooseGamePlayerQuery();

  const checkAnswer = async (currentInput: string) => {
    if (currentInput && myGooseGamePlayer) {
      try {
        await submitQuestion({
          variables: {
            questId: quest.id,
            eventAttendeeId:
              myGooseGamePlayer.myGooseGamePlayer.event_attendee_id,
            answer: currentInput,
          },
        });
        refetchQuest();
        setIsAnswerCorrect(true);
        setIsCompleted(true);
      } catch (_) {
        setIsAnswerCorrect(false);
      }
    }
  };

  return (
    <Modal isOpen={isOpen}>
      {quest.type === QuestType.Question ? (
        <InputQuestView
          quest={quest}
          answer={answer}
          updateAnswer={(e) => setAnswer(e)}
          progress={progress}
        />
      ) : (
        <ScannedQuestView quest={quest} progress={progress} />
      )}
      <Spacer height={24} />
      {quest.type === QuestType.Question ? (
        <FooterWrapper>
          {isAnswerCorrect !== null &&
            (isAnswerCorrect ? (
              <Alert color={"success"}>
                <AlertWrapper>
                  <CheckCircleIcon width={20} height={20} />
                  {"Correct! You have successfully completed the quest."}
                </AlertWrapper>
              </Alert>
            ) : (
              <Alert color={"danger"}>
                <AlertWrapper>
                  <XCircleIcon width={20} height={20} />
                  {"Not quite..."}
                </AlertWrapper>
              </Alert>
            ))}
          <FooterActions
            confirmText={isCompleted ? "Close" : "Submit"}
            onCancel={isCompleted ? undefined : onClose}
            onConfirm={isCompleted ? onClose : () => checkAnswer(answer)}
          />
        </FooterWrapper>
      ) : (
        <FooterActions confirmText={"Close"} onConfirm={onClose} />
      )}
    </Modal>
  );
};

const AlertWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

const FooterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export default QuestModal;
